import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';
import { FeatureComparatorPage } from '@/features/misc';

export const FeatureComparator = () => {
  return (
    <PublicLayout className="flex">
      <Head page="Comparator" />
      <FeatureComparatorPage publicPage={true} />
    </PublicLayout>
  );
};
